import { QUERY_KEYS } from 'api/query-keys';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { sharedPaymentService } from 'api/services';
import { Site } from 'shared/hooks';

type BlockPaymentMutationContext = { site: Site; paymentId: string };
type BlockPaymentMutationOptions = UseMutationOptions<unknown, Error, BlockPaymentMutationContext>;
export const useBlockPayment = (options?: BlockPaymentMutationOptions) => {
  const mutationFn = async ({ site, paymentId }: BlockPaymentMutationContext) =>
    await sharedPaymentService.blockPayment(site, paymentId);
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation(mutationFn, {
    onSuccess: async (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.payments());
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  });
};
